<div #dialog>
  <sm-form [form]="form" [style.position]="'relative'">
  </sm-form>
</div>
<p-footer>
  @for (button of buttons; track button) {
    <button class="mr-1" type="button" pButton [icon]="button.icon" [label]="button.caption"
    (click)="click(button)"></button>
  }
</p-footer>
